/**
 * Copyright © Smartex Canada All rights reserved.
 * See LICENSE for license details.
 */

import { requestJson, type RequestError } from "@/utils/request";
import type { ResultAsync } from "@/utils/result";

export type GetCartQtyResult = {
    qty: number
};

export type GetCartQtyError = RequestError;

export function getCartQty(): ResultAsync<GetCartQtyResult, GetCartQtyError> {
    return requestJson(window.themeConfig.urls.cart.qty);
}
